import "./boot/wakeBackend";
import "./boot/preloadAppRoute";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ThemeProvider } from "@/contexts/ThemeContext";

document.getElementById("tk-boot-slow")?.remove();
document.documentElement.style.backgroundColor = "";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
